import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const apiClient = axios.create({
  baseURL: apiUrl,
  withCredentials: true
});

const getAuthToken = () => {
  try {
    const authStorage = localStorage.getItem('auth-storage');
    if (authStorage) {
      const parsed = JSON.parse(authStorage);
      const token = parsed.state?.token;
      const expirationTime = parsed.state?.expirationTime;
      
      if (token && expirationTime && new Date() < new Date(expirationTime)) {
        return token;
      }
    }
    return null;
  } catch (error) {
    console.error('Error getting auth token:', error);
    return null;
  }
};

apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Limpiar localStorage de Zustand
      const authStorage = localStorage.getItem('auth-storage');
      if (authStorage) {
        try {
          const parsed = JSON.parse(authStorage);
          parsed.state.token = null;
          parsed.state.expirationTime = null;
          parsed.state.isAuthenticated = false;
          localStorage.setItem('auth-storage', JSON.stringify(parsed));
        } catch (e) {
          localStorage.removeItem('auth-storage');
        }
      }
      
      // También limpiar Redux storage si existe
      try {
        const persistedState = localStorage.getItem('persist:root');
        if (persistedState) {
          const parsed = JSON.parse(persistedState);
          if (parsed.auth) {
            const authState = JSON.parse(parsed.auth);
            authState.token = null;
            authState.expirationTime = null;
            parsed.auth = JSON.stringify(authState);
            localStorage.setItem('persist:root', JSON.stringify(parsed));
          }
        }
      } catch (e) {
        console.error('Error clearing Redux persisted state:', e);
      }
      
      // Solo redireccionar si no estamos ya en la página de login
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;